module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cn":{"back_to_top":"返回顶部"},"en":{"back_to_top":"Back Top"}}')
  delete Component.options._Ctor
}
